// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/app-" + chunkId + "." + {"3042":"c04d977e","5041":"fd7f35fb","7087":"db867aaf","9725":"a5f3231f"}[chunkId] + ".chunk.css";
};